export default __webpack_public_path__ + "static/media/weact_logo.8748e477.png";